import { render, staticRenderFns } from "./TopPartsWidget.vue?vue&type=template&id=403ecfa6&scoped=true"
import script from "./TopPartsWidget.vue?vue&type=script&lang=js"
export * from "./TopPartsWidget.vue?vue&type=script&lang=js"
import style0 from "./TopPartsWidget.vue?vue&type=style&index=0&id=403ecfa6&prod&scoped=true&lang=css"
import style1 from "./TopPartsWidget.vue?vue&type=style&index=1&id=403ecfa6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403ecfa6",
  null
  
)

export default component.exports